import { rest } from 'msw';
import { generateLegacyUsers } from '../fixtures/organization.faker';

export const organizationHandler = [
    rest.get('/admin/legacy-organizations', (req, res, ctx) => {
        return res(
            // Respond with a 200 status code
            ctx.status(200),
            ctx.json(generateLegacyUsers(5)),
        );
    }),
];
